import { AuthKitProvider } from '@workos-inc/authkit-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { ADMIN_LOGIN_PATH, adminLogoutDestination, isAdminLogoutPath } from './auth-routes.ts';
import { workspaceReturnPath } from './workspace-routes.ts';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Admin app root is missing');
}

if (isAdminLogoutPath(window.location.pathname)) {
  window.location.replace(
    adminLogoutDestination(window.location.href, __ADMIN_UNAUTHORIZED_REDIRECT_URL__),
  );
} else {
  createRoot(root).render(
    <StrictMode>
      <AuthKitProvider
        apiHostname={__ADMIN_AUTHKIT_HOSTNAME__ || undefined}
        clientId={__ADMIN_WORKOS_CLIENT_ID__}
        devMode={__ADMIN_AUTHKIT_DEV_MODE__ ? true : undefined}
        redirectUri={`${window.location.origin}${ADMIN_LOGIN_PATH}`}
        onRedirectCallback={({ state }) => {
          window.history.replaceState({}, '', workspaceReturnPath(state));
          window.dispatchEvent(new PopStateEvent('popstate'));
        }}
      >
        <App />
      </AuthKitProvider>
    </StrictMode>,
  );
}
